// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-2e9bffd6] .custom-input-password .ant-input-password-icon {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  color: red !important;\n}\n.custom-input-password .ant-input-password-icon svg[data-v-2e9bffd6] {\n  display: none; /* 隐藏默认的眼睛图标 */\n}\n.custom-input-password .ant-input-password-icon .anticon-eye-invisible[data-v-2e9bffd6] {\n  display: block; /* 显示眼睛闭着的图标 */\n}\n", ""]);
// Exports
module.exports = exports;
